import { render, staticRenderFns } from "./SAItemCard.html?vue&type=template&id=7194a80a&scoped=true&"
import script from "./SAItemCard.ts?vue&type=script&lang=ts&"
export * from "./SAItemCard.ts?vue&type=script&lang=ts&"
import style0 from "./SAItemCard.css?vue&type=style&index=0&id=7194a80a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7194a80a",
  null
  
)

export default component.exports